module.exports = __webpack_public_path__ + "img/MEDIA011.df96844f.jpg";